/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} My_Grower_Report_Last_YearInputs */

const vi_my_grower_report_last_year = /** @type {(inputs: My_Grower_Report_Last_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Năm ngoái (${i?.year})`)
};

/**

* @param {My_Grower_Report_Last_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_last_year = /** @type {((inputs: My_Grower_Report_Last_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Last_YearInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_last_year(inputs)
});